import { Controller } from '@hotwired/stimulus'

export default class NavigationUrlController extends Controller {
  connect() {
    this.element.dataset.action = ''
  }

  click(e) {
    if (!e.defaultPrevented) {
      Turbo.visit(e.currentTarget.dataset.url)
    }
  }

  turboClick(event) {
    event.stopPropagation()
    event.preventDefault()
    Turbo.visit(event.currentTarget.href, { frame: 'modal_content' })
  }
}
